import React, { useRef, useState } from "react";

// Import Swiper styles

// import { Bookmark, MapPin, ChevronRight, ChevronLeft } from "react-feather";
// import Swiper core and required modules
import playbutton from "views/home/img/employestory/playbutton.png";
import "swiper/swiper.min.css";
import "swiper/components/effect-fade/effect-fade.min.css";
import "swiper/components/navigation/navigation.min.css";
import "swiper/components/pagination/pagination.min.css";
import SwiperCore, { EffectFade, Navigation, Pagination } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
// install Swiper modules
import employeestory from "../img/employestory/testimonial.png";
import { connect } from "react-redux";
import { GetAllStoriesAction } from "store/Story";
class EmployeeStory extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stories: [],
      currentQuestion: "",
      currentAnswer: "",
      currentName: "",
      currentPosition: "",
    };
  }
  setCurrentActiveStory(w, x, y, z, a) {
    this.setState({
      currentQuestion: w,
      currentAnswer: x,
      currentName: y,
      currentPosition: z,
      currentImg: a,
    });
  }
  async componentWillMount() {
    try {
      // let response = await this.props.GetAllstories();
      // console.log(response);
      // if (response.ResponseCode == 100) {
      // this.setState({ stories: response.Data });
      // this.setCurrentActiveStory(
      //   response.Data[0].s_question,
      //   response.Data[0].s_response,
      //   response.Data[0].s_employee_name,
      //   response.Data[0].s_employee_position,
      //   response.Data[0].s_path
      // );
      // console.log(this.state.stories);
      // }
    } catch (error) {}

    // this.props.getEmployeeAction()
  }
  addDefaultSrc(ev) {
    ev.target.src = employeestory;
  }

  render() {
    return (
      <>
        <div className="bg-f8f8f8 lg:px-16 md:px-16 px-6 lg:py-12 md:py-12 py-8">
          <div className="flex justify-between items-center  lg:mb-8 md:mb-8 mb-6">
            <h2 className="fsize28 font-bold sm-fsize16">Employee’s Story :</h2>
          </div>

          <div>
            <Swiper
              spaceBetween={30}
              effect={"fade"}
              navigation={false}
              pagination={{
                clickable: true,
              }}
              className="mySwiper relative swiperpagination-dot"
            >
              <SwiperSlide className="relative bg-f8f8f8">
                <div class="lg:flex md:flex w-full ">
                  <div className="relative lg:w-7/12 md:w-7/12 w-full">
                    <img
                      onError={this.addDefaultSrc}
                      // src={employeestory}
                      src={
                        this.props.stories
                          ? `${
                              process.env.REACT_APP_IMAGE_BASE_MG +
                              this.state.currentImg
                            }`
                          : "ok.png"
                      }
                      alt="employee story"
                      className="w-full employe-s-w w-full employe-s-w rounded-lg"
                    />
                    {/* <div className="playbutton-place w-full">
                      {" "}
                      <img
                        src={playbutton}
                        alt="playbutton"
                        className="playbutton-w"
                      />
                    </div> */}
                  </div>

                  <card class="lg:w-5/12	 md:w-5/12	 w-full relative">
                    <div className="lg:px-12 md:px-12 lg:mt-0 md:mt-0 mt-4">
                      <h1 className="font-semibold emply-titile text-left">
                        {this.state.currentQuestion ||
                          `How would you describe career development opportunities at
                    ICICI?`}
                      </h1>
                      <p className="font-medium emply-subtext lg:mt-8 md:mt-8 mt-4 text-left">
                        {this.state.currentAnswer ||
                          `“I’m most excited about the opportunity to grow at ICICI.”`}
                      </p>

                      <p className="empl-tagline-p font-semibold lg:mt-8 md:mt-8 mt-4 text-left">
                        -- {this.state.currentName || "Archana Thalekar"},{" "}
                        <span className="emply-tag-n font-normal">
                          {this.state.currentPosition ||
                            "Senior Software Engineer"}
                        </span>
                      </p>
                    </div>
                  </card>
                </div>
              </SwiperSlide>
              <div className="">
                <div className="story-rounded-card w-2/5 flex flex-wrap lg:mt-12 md:mt-12 mt-8 story-user-v lg:absolute md:absolute lg:bottom-0 md:bottom-0">
                  {this.props.stories &&
                    this.props.stories.Data &&
                    this.props.stories.Data.map(
                      (story, index) =>
                        index > 0 &&
                        index < 5 && (
                          <div className="mr-4 rounded-full border-2yel">
                            <img
                              onClick={() =>
                                this.setCurrentActiveStory(
                                  story.s_question,
                                  story.s_response,
                                  story.s_employee_name,
                                  story.s_employee_position,
                                  story.s_employee_profile_img_path
                                )
                              }
                              onError={this.addDefaultSrc}
                              src={`${
                                process.env.REACT_APP_IMAGE_BASE_MG +
                                story.s_employee_profile_img_path
                              }`}
                              alt="story"
                              className="mr-4 h-60px w-60px m-auto rounded-full cursor-pointer grayscale"
                              key={index}
                            />
                          </div>
                        )
                    )}
                  {/* <img src={story1} alt='story' className='mr-4' />
                    <img src={story2} alt='story' className='mr-4' />
                    <img src={story3} alt='story' className='mr-4' />
                    <img src={story4} alt='story' className='mr-4' /> */}
                </div>
                <div className="relative cursor-pointer">
                  {/* <img src={story4} alt='story' /> */}
                  <p className="storymore">
                    +
                    {this.props.stories &&
                      this.props.stories.Data &&
                      this.props.stories.Data.length}
                  </p>
                </div>
              </div>
            </Swiper>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  // console.log('state', state.Home.home.GETPROGRAMMING)
  return {
    employee: state.Home.home.EMPLOYEE,
    stories: state.Story.EmployeeStory.ALLSTORY,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetAllstories: async () => await dispatch(GetAllStoriesAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeStory);
